import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 * 笔记列表
 * @param params
 * 
*/

export const noteList = params => Http.get(`${baseUrl}/notes`, { params })

/**
 * 新增笔记
 * @param params
 * 
*/

export const addNote = params => Http.post(`${baseUrl}/notes`,  params )

/**
 * 编辑笔记
 * @param params
 * 
*/

export const editNote = params => Http.put(`${baseUrl}/notes`,  params )

/**
 * 删除笔记
 * @param notesId
 * 
*/

export const delNote = notesId => Http.delete(`${baseUrl}/notes/${notesId}` )
